import logo from "./logo.svg";
import "./App.scss";
import { useEffect, useState } from "react";

var toHHMMSS = (secs) => {
  var hours = Math.floor(secs / 3600);
  secs %= 3600;
  var minutes = Math.floor(secs / 60);
  var seconds = secs % 60;
  return (
    String(hours).padStart(2, "0") +
    ":" +
    String(minutes).padStart(2, "0") +
    ":" +
    String(seconds).padStart(2, "0")
  );
};

function App() {
  const [time, setTime] = useState(Date.now());
  const timeDiff =
    Math.round((new Date("January 1 2100, 00:00:00") - time) / 1000) % 86400;

  useEffect(() => {
    const interval = setInterval(() => setTime(Date.now()), 100);
    return () => {
      clearInterval(interval);
    };
  }, []);

  var timeString = toHHMMSS(timeDiff);
  return (
    <div className="App">
      <div id="countdown-container">
        {Array.from(timeString).map(function (object, i) {
          var num = parseInt(object);
          if (object == ":") {
            num = 10;
          }
          return (
            <div
              key={i}
              style={{
                transform:
                  "translateY(" +
                  String(
                    ((1277.78 / 2) * 3) / 2 - (1277.78 * (num + 10)) / 2 / 10
                  ) +
                  "px)",
              }}
              className="countdown-digit"
            >
              0<br />1<br />2<br />3<br />4<br />5<br />6<br />7<br />8<br />9
              <br />:<br />0<br />1<br />2<br />3<br />4<br />5<br />6<br />7
              <br />8<br />9
              <br />:<br />0<br />1<br />2<br />3<br />4<br />5<br />6<br />7
              <br />8<br />9
              <br />:
            </div>
          );
        })}
      </div>
      <div id="countdown-overlay"></div>
    </div>
  );
}

export default App;
